import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const StreetView = ({
  color,
  width,
  height,
  x = '0px',
  y = '0px',
  scale = 0,
}: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '22px'}
      height={height || '22px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M7.361,15.9c-1.927,0.558-3.209,1.555-3.209,2.69c0,1.751,3.062,3.179,6.848,3.179
        c3.776,0,6.848-1.428,6.848-3.179c0-1.135-1.282-2.133-3.219-2.69l-0.225,0.988c1.399,0.391,2.299,1.008,2.299,1.702
        c0,1.174-2.553,2.123-5.704,2.123s-5.713-0.949-5.713-2.123c0-0.695,0.91-1.311,2.309-1.702L7.361,15.9z"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
      <path
        d="M11.646,6.606c1.008,0,1.976,0.362,2.671,0.978c0.704,0.626,1.086,1.458,1.086,2.319v2.788
        c0,0.117-0.059,0.245-0.176,0.352c-0.117,0.108-0.284,0.166-0.47,0.166h-1.008l-1.712,5.136H9.96L8.248,13.21H7.24
        c-0.186,0-0.352-0.059-0.47-0.166c-0.117-0.108-0.176-0.235-0.176-0.352V9.903c0-0.861,0.382-1.693,1.086-2.319
        c0.695-0.616,1.663-0.978,2.671-0.978H11.646z"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
      <circle cx="11" cy="3.2" r="2.5" stroke={color || 'currentColor'} strokeWidth="1" />
    </StyledSvg>
  );
};
